import React from 'react';
import {
	IonBadge,
	IonIcon,
	IonLabel,
	IonRouterOutlet,
	IonTabBar,
	IonTabButton,
	IonTabs,
} from '@ionic/react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { _store } from '_Store';
import { cartFx, images } from 'utils';

// :: screens
import Login from './pages/Auth/Login';
import Reset from './pages/Auth/Reset';
import Signup from './pages/Auth/Signup';
import Verify from './pages/Auth/Verify';

import Cart from './pages/Cart';
// import Item3 from './pages/Item3';
import Help from './pages/Help';
import User from './pages/User/_User';
import Home from './pages/Home';
import Stores from './pages/Stores';
import Order from './pages/User/Order';
import Search from './pages/Search';
import Review from './pages/User/Review';
import Orders from './pages/User/Orders';
import Webhook from './pages/Webhook';
import Category from './pages/Category';
import Location from './pages/Location';
import Favorites from './pages/User/Favourites';
import Wallet from './pages/User/Wallet';

const Rautes = () => {
	const {
		__data: { location, cart },
	} = _store.useState();

	const lokation = useLocation();

	const routes = [
		// { path: '/welcome', component: Welcome, exact: true, auth: false, },
		{ path: '/login', component: Login, exact: true, auth: false },
		{ path: '/reset', component: Reset, exact: true, auth: false },
		{ path: '/signup', component: Signup, exact: true, auth: false },
		{ path: '/verify', component: Verify, exact: true, auth: false },

		{
			path: '/home',
			icon: images.Home,
			icon2: images.HomeRed,
			component: Stores,
			tab: true,
			label: 'Home',
		},
		{
			path: '/store/:id',
			icon: images.Stores,
			icon2: images.StoresRed,
			component: Home,
			auth: true,
		},
		{
			path: '/cart',
			icon: images.Cart,
			icon2: images.CartRed,
			component: User,
			auth: true,
			tab: true,
			label: 'Cart',
		},
		{
			path: '/orders',
			icon: images.Orders,
			icon2: images.OrdersRed,
			component: Orders,
			auth: true,
			tab: true,
			label: 'Orders',
		},
		{
			path: '/help',
			icon: images.Help,
			icon2: images.HelpRed,
			component: User,
			auth: true,
			tab: true,
			label: 'Support',
		},
		{
			path: '/user',
			icon: images.Profile,
			icon2: images.ProfileRed,
			component: User,
			auth: true,
			tab: true,
			label: 'Profile',
			exact: true,
		},

		{ path: '/cart', component: Cart, auth: true },
		{ path: '/c/:slug.:id', component: Category, auth: true },
		{ path: '/user/orders', component: Orders, auth: true, exact: true },
		{ path: '/user/orders/:id', component: Order, auth: true, exact: true },
		{ path: '/user/rate/:id', component: Review, auth: true, exact: true },
		{
			path: '/user/favorites',
			component: Favorites,
			auth: true,
			exact: true,
		},
		{ path: '/user/wallet', component: Wallet, auth: true, exact: true },
		{ path: '/help', component: Help, auth: true, exact: false },
		{ path: '/help/:orderId', component: Help, auth: true, exact: false },
		{ path: '/help/:orderId/low', component: Help, auth: true, exact: false },
		{ path: '/search', component: Search, auth: true, exact: true },
		{ path: '/location', component: Location, auth: true, exact: true },
		{ path: '/webhook/:id', component: Webhook, auth: true, exact: true },
		{ path: '/orders/:id', component: Order, auth: true, exact: true },
	].filter((r) => location.address.x > 1 || ['/location'].includes(r.path));

	const hasLocation = !!(
		location.address.iso &&
		location.address.x &&
		location.address.y
	);

	return (
		<React.Fragment>
			<IonTabs>
				<IonRouterOutlet>
					{routes
						.filter(
							(route) =>
								!route.tab ||
								['/home', '/user', '/stores', '/orders'].includes(route.path)
						)
						.map((route) => (
							<Route
								key={route.path}
								path={route.path}
								exact={true}
								render={(p) => <route.component {...p} />}
							/>
						))}
					<Route
						exact
						path="/"
						render={() => <Redirect to={hasLocation ? '/home' : '/location'} />}
					/>
					<Redirect to={hasLocation ? '/home' : '/location'} />
				</IonRouterOutlet>

				<IonTabBar slot="bottom" className={!hasLocation ? 'hide' : ''}>
					{routes
						.filter((tab) => tab.tab)
						.map((tab) => {
							const isActive =
								lokation.pathname.split('/')[1] === tab.path.split('/')[1];
							return (
								<IonTabButton
									key={tab.path}
									tab={tab.path.replace('/', '')}
									href={tab.path}
								>
									{isActive ? (
										<IonIcon icon={tab.icon2} />
									) : (
										<IonIcon icon={tab.icon} />
									)}
									<IonLabel className={isActive ? 'primary' : ''}>
										{tab.label}
									</IonLabel>
									{cart.items.length > 0 && tab.path === '/cart' && (
										<IonBadge>{cartFx.totalItems(cart.items)}</IonBadge>
									)}
								</IonTabButton>
							);
						})}
				</IonTabBar>
			</IonTabs>
		</React.Fragment>
	);
};

export default Rautes;
